<template>
  <div class="tfm-panel">
    <p class="text-body-2 text-medium-emphasis mb-4">
      变压器保护策略按「时段 + 规则」配置 SOC、容量区间与功率模式。点击下方按钮在弹窗中编辑完整策略树。
    </p>
    <v-alert type="info" variant="tonal" density="compact" class="mb-4" rounded="lg">
      提示：停机切换为其他模式时，时间有延迟
    </v-alert>
    <v-btn color="primary" variant="flat" rounded="lg" @click="dialogOpen = true">编辑变压器保护策略</v-btn>
    <TransformerStrategyDialog v-model="dialogOpen" @saved="onSaved" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TransformerStrategyDialog from '../TransformerStrategyDialog.vue'

const dialogOpen = ref(false)
const lastSaved = ref(null)

function onSaved(data) {
  lastSaved.value = data
}

defineExpose({
  getDraft: () => ({
    mode: 'transformerProtection',
    segments: lastSaved.value,
  }),
})
</script>

<style scoped>
.tfm-panel {
  max-width: 720px;
}
</style>
